module.exports = __webpack_public_path__ + "img/caliber2019_transparent.8590a82e.png";